<div *ngIf="hasSearched" id="search-results-header" [style.background-color]="themeColor">
    <div class="job-title"><strong>Job Title</strong></div>
    <div *ngIf="showDistance" class="distance"><strong>Distance</strong></div>
    <div class="location"><strong>Address</strong></div>
    <div *ngIf="jobTypeFilter" class="category"><strong>Job Type</strong></div>
    <div class="share-button"></div> <!-- Intentionally blank -->
    <div class="apply-button"></div> <!-- Intentionally blank -->
</div>

<div *ngIf="jobResults.length" id="search-results">
    <div *ngFor="let job of jobResults | paginate: config; let index = index" class="job-listing">
        <jobs-search-results-job-listing class="full" [showShare]="showShare" [job]="job" [index]="index" [eventName]="'cp_resultclick'" [showDistance]="showDistance" [themeColor]="themeColor" [showApply]="showApply"></jobs-search-results-job-listing>
    </div>
</div>

<div *ngIf="!jobResults.length && hasSearched" id="no-results">
    <h3 *ngIf="currentLocation">No jobs near {{currentLocation}}</h3>
    <h3 *ngIf="!currentLocation">No jobs</h3>
    <p>Reset your filters, search a new location or check back later for new jobs.</p>
</div>
